import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import useMediaQuery from '@eversports/klimt-design-components/use-media-query'
import useTheme from '@eversports/klimt-design-components/use-theme'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Dialog, { DialogContent } from '@eversports/klimt-primitives/legacy/Dialog'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import { useEffect, useRef } from 'react'

import CloseIcon from '../../../../assets/icons/close.svg'
import Drawer from '../../../../components/Drawer'

import ReferMobileImage from './assets/Refer-Mobile-or-sheet.webp'
import WideModalImage from './assets/Wide-modal.webp'
import { VenueReferAFriendOverlayContent } from './VenueReferAFriendOverlayContent'

interface Props {
  isOpen: boolean
  toggleDialog: () => void
  venueName: string
  referralCode: string
  rewardDescription: string
  shareText: string
}

export function VenueReferAFriendOverlay({
  isOpen,
  toggleDialog,
  venueName,
  referralCode,
  rewardDescription,
  shareText,
}: Props) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const hasOpenedRef = useRef(false)
  const { amplitude } = useAmplitude()

  if (isOpen) {
    hasOpenedRef.current = true
  }

  useEffect(() => {
    if (isOpen) {
      amplitude?.logEvent('Viewed Refer Modal', { from: 'venue profile' })
    }
  }, [isOpen])

  if (!hasOpenedRef.current) return null

  return isMobile ? (
    <Drawer
      open={isOpen}
      onClose={toggleDialog}
      sx={{
        '& .MuiDrawer-paper': {
          maxHeight: '85vh',
          overflowY: 'auto',
          paddingX: 4,
          paddingTop: 4,
          border: '1px solid',
          borderColor: 'var(--color-border-divider)',
          borderRadius: '16px 16px 0px 0px',
        },
      }}
    >
      <VenueReferAFriendOverlayContent
        venueName={venueName}
        referralCode={referralCode}
        rewardDescription={rewardDescription}
        shareText={shareText}
        image={ReferMobileImage}
      />
    </Drawer>
  ) : (
    <Dialog open={isOpen} onClose={toggleDialog} maxWidth="sm">
      <DialogContent>
        <Box sx={{ cursor: 'pointer', justifySelf: 'end', marginBottom: 1 }}>
          <Icon onClick={toggleDialog} src={CloseIcon} size="default" color="darkgray" />
        </Box>
        <VenueReferAFriendOverlayContent
          venueName={venueName}
          referralCode={referralCode}
          rewardDescription={rewardDescription}
          shareText={shareText}
          image={WideModalImage}
        />
      </DialogContent>
    </Dialog>
  )
}
